import ResetPassword from './ResetPassword';

const Emails = { ResetPassword };

export default Emails;
